import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent extends BaseCrudComponent {

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    dstart:any;
    dend:any;
    zones:any;
    theaders:any;

    offline_key_list = 'SALES_CLIENTS';
    offline_date = '';
    zoom = 15;
    track_lat:any;
    track_lng:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'Location/All';
	    this.update_url = 'Location/Save';
        this.header = {};
        this.zones = [];

        this.srv.offline.subscribe(r => {
            this.isOffline = r;
        });

        //this.isOffline = false;

        this.theaders = [
        	{ field: 'clientCode', header: 'Código', sortable:true, sortfield:'clientCode', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
            { field: 'clientName', header: 'Nombre', sortable:true, sortfield:'clientName', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
            { field: 'recipientCode', header: 'Cod. Sucursal', sortable:true, sortfield:'recipientCode', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
            { field: 'recipientName', header: 'Sucursal', sortable:true, sortfield:'recipientName', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
            { field: 'city', header: 'Ciudad', sortable:true, sortfield:'city', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
            { field: 'location', header: 'Ubicación', sortable:false, sortfield:'location', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''}
        ];
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.curr_date = this.momentjs().tz('America/Guayaquil');
        this.trackMe();

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        this.rows = [];

        if(this.isOffline){
            this.srv.getOfflineData(this.offline_key_list).then(x => {
                //console.log(x);
                var rs = x.data;
                if( (rs != null) && (rs != undefined) ){
                    this.parseDetails(rs);
                    this.offline_date = x.last_update;
                }
            });
        }
        else{
            this.loadingList = true;
            this.srv.getCall(qst).subscribe(x => {
                this.loadingList = false;

                if(x.status){
                    var rs = x.data;
                    this.srv.saveOfflineData(this.offline_key_list, rs);
                    this.parseDetails(rs);
                }
            });
        }

    }

    parseDetails(rs:any){
    	this.rows = [];
    	this.rawdata = [];
    	var tmp:any;
    	var tobj:any;
    	let coords:any;

    	/*rs.forEach(r => {
    		r.lat = '';
    		r.lng = '';

    		if( r.location != '' ){
    			coords = r.location.split(';');
    			r.lat = parseFloat(coords[0]);
                r.lng = parseFloat(coords[1]);
    		}
    		
    	});*/

    	this.rawdata = rs;
    	this.rows = this.rawdata;
    }

    openUpdateModal(content:any, obj:any){
        this.u_obj = obj;
        let coords:any;

        /*this.u_obj.lat = '';
		this.u_obj.lng = '';*/

		if( this.u_obj.location != '' ){
			coords = this.u_obj.location.split(';');
			this.u_obj.lat = parseFloat(coords[0]);
            this.u_obj.lng = parseFloat(coords[1]);
		}
        else{
            this.u_obj.lat = this.track_lat;
            this.u_obj.lng = this.track_lng;
        }

        super.openCreateModalLG(content);
        //this.marker={"name":"", "lat":this.u_obj.lat, "lng":this.u_obj.long};
    }

    public updateItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        if( (form['lat'] == '') || (form['lng'] == '') ){
            Swal.fire('No hay coordenadas', '', 'error');
            return;
        }

        var to:any;
        to = {};
        to.ClientCode = form.clientCode;
        to.RecipientCode = form.recipientCode;
        to.Location = form['lat'] + ';' + form['lng'];
        
        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

    public placeMarker($event){
        this.u_obj.lat = $event.coords.lat;
        this.u_obj.lng = $event.coords.lng;
    }

    trackMe() {
  	    if (navigator.geolocation) {
  	      	//this.isTracking = true;
  	      	navigator.geolocation.watchPosition((position) => {
	        	this.track_lat = position.coords.latitude;
	        	this.track_lng = position.coords.longitude;
	        	//console.log(this.track_lat);
  	      	});
  	    } else {
  	       alert("Geolocation is not supported by this browser.");
  	    }
  	}

  	setCurrentLocation(obj:any){
  		if( (this.track_lat != undefined) && (this.track_lat != '') ){
  			obj.lat = this.track_lat;
        	obj.lng = this.track_lng;
  		}
  	}

}
